import { useApp } from '../../context/AppContext';
import { useT } from '../../i18n';
import { useCurrentFacility } from '../../hooks/useAppData';
import { facilityName } from '../../lib/patient';
import { ClinicLogo, SurakshaMark } from '../common/Brand';
import { LangToggle } from '../common/LangToggle';
import { DemoControls } from './DemoControls';
import { DEMO_MODE } from '../../config/demo';
import { ProfileMenu } from './ProfileMenu';

function BrandBlock() {
  const { role, lang } = useApp();
  const t = useT();
  const { data: facility } = useCurrentFacility();

  if (role === 'super_admin') {
    return (
      <div className="flex min-w-0 items-center gap-3" data-testid="header-brand">
        <SurakshaMark />
        <div className="min-w-0">
          <p className="truncate font-bold text-slate-900" data-testid="header-title">{t('app.name')}</p>
          <p className="truncate text-xs text-slate-500">{t('app.platformConsole')}</p>
        </div>
      </div>
    );
  }
  if (!facility) return <div className="h-10 w-40 animate-pulse rounded-xl bg-slate-100" />;
  return (
    <div className="flex min-w-0 items-center gap-3" data-testid="header-brand">
      <ClinicLogo src={facility.logoUrl} alt={facility.displayNameEn} />
      <div className="min-w-0">
        <p className="truncate font-bold leading-tight text-slate-900" data-testid="header-title">{facilityName(facility, lang)}</p>
        <p className="truncate text-xs text-slate-500">{facility.city}, {facility.state}</p>
      </div>
    </div>
  );
}

export function TopBar() {
  return (
    <header className="print:hidden sticky top-0 z-30 border-b border-sc-line bg-white" data-testid="top-bar">
      <div className="h-1 bg-brand" data-testid="brand-strip" />
      <div className="flex h-16 items-center gap-3 px-4 lg:px-8">
        <BrandBlock />
        <div className="ml-auto flex shrink-0 items-center gap-2 sm:gap-3">
          {DEMO_MODE && (
            <div className="hidden md:block">
              <DemoControls />
            </div>
          )}
          <LangToggle />
          <ProfileMenu />
        </div>
      </div>
      {DEMO_MODE && (
        <div className="border-t border-sc-line bg-sc-bg px-4 py-2 md:hidden">
          <DemoControls suffix="-mobile" />
        </div>
      )}
    </header>
  );
}
